export const state = {
  selectedCycleObject: null,
  averageCycleDuration: null,
  signatureTimeDuration: null,
};

export const getters = {
  getSelectedCycleObject: (state) => state.selectedCycleObject,
  getAverageCycleDuration: (state) => state.averageCycleDuration,
  getSignatureTimeDuration: (state) => state.signatureTimeDuration,
};

export const mutations = {
  /**
     *
     * @param state
     * @param newCycleObject
     */
  commitSelectedCycleObject(state, newCycleObject) {
    state.selectedCycleObject = newCycleObject;
  },
  /**
     *
     * @param state
     * @param averageCycleDuration
     */
  commitAverageCycleDuration(state, averageCycleDuration) {
    state.averageCycleDuration = averageCycleDuration;
  },
  /**
     *
     * @param state
     * @param signatureTimeDuration
     */
  commitSignatureTimeDuration(state, signatureTimeDuration) {
    state.signatureTimeDuration = signatureTimeDuration;
  },
};

export const actions = {
  /**
     *
     * @param context
     * @param newCycleObject
     */
  saveSelectedCycleObject(context, newCycleObject) {
    context.commit('commitSelectedCycleObject', newCycleObject);
  },
  /**
     *
     * @param context
     * @param averageCycleDuration
     */
  saveAverageCycleDuration(context, averageCycleDuration) {
    context.commit('commitAverageCycleDuration', averageCycleDuration);
  },
  /**
     *
     * @param context
     * @param signatureTimeDuration
     */
  saveSignatureTimeDuration(context, signatureTimeDuration) {
    context.commit('commitSignatureTimeDuration', signatureTimeDuration);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
